export const GOOGLE_RECAPTCHA_KEY = '6Ld5IwMcAAAAADXzu3fcruh6sGK1RvPW8Ht49qBG';
export default null;
